import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

//Redux Types
export enum CustomerCICReportingReduxTypes {
    FETCH_CUSTOMER_CIC_REPORTINGS = "@@auth/FETCH_CUSTOMER_CIC_REPORTINGS",
    FETCH_CUSTOMER_CIC_REPORTINGS_SUCCESS = "@@auth/FETCH_CUSTOMER_CIC_REPORTINGS_SUCCESS",
    FETCH_CUSTOMER_CIC_REPORTINGS_ERROR = "@@auth/FETCH_CUSTOMER_CIC_REPORTINGS_ERROR",

    FETCH_CUSTOMER_CIC_REPORTING = "@@auth/FETCH_CUSTOMER_CIC_REPORTING",
    FETCH_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_SUCCESS",
    FETCH_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_ERROR",

    FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION",
    FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_SUCCESS = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_SUCCESS",
    FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_ERROR = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_ERROR",

    FETCH_CUSTOMER_CIC_REPORTING_VERSION = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION",
    FETCH_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS",
    FETCH_CUSTOMER_CIC_REPORTING_VERSION_ERROR = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION_ERROR",

    FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS",
    FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_SUCCESS = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_SUCCESS",
    FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_ERROR = "@@auth/FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_ERROR",

    CREATE_CUSTOMER_CIC_REPORTING = "@@auth/CREATE_CUSTOMER_CIC_REPORTING",
    CREATE_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/CREATE_CUSTOMER_CIC_REPORTING_SUCCESS",
    CREATE_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/CREATE_CUSTOMER_CIC_REPORTING_ERROR",

    UPDATE_CUSTOMER_CIC_REPORTING = "@@auth/UPDATE_CUSTOMER_CIC_REPORTING",
    UPDATE_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/UPDATE_CUSTOMER_CIC_REPORTING_SUCCESS",
    UPDATE_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/UPDATE_CUSTOMER_CIC_REPORTING_ERROR",

    DELETE_CUSTOMER_CIC_REPORTING = "@@auth/DELETE_CUSTOMER_CIC_REPORTING",
    DELETE_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/DELETE_CUSTOMER_CIC_REPORTING_SUCCESS",
    DELETE_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/DELETE_CUSTOMER_CIC_REPORTING_ERROR",

    APPROVE_CUSTOMER_CIC_REPORTING = "@@auth/APPROVE_CUSTOMER_CIC_REPORTING",
    APPROVE_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/APPROVE_CUSTOMER_CIC_REPORTING_SUCCESS",
    APPROVE_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/APPROVE_CUSTOMER_CIC_REPORTING_ERROR",

    REJECT_CUSTOMER_CIC_REPORTING = "@@auth/REJECT_CUSTOMER_CIC_REPORTING",
    REJECT_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/REJECT_CUSTOMER_CIC_REPORTING_SUCCESS",
    REJECT_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/REJECT_CUSTOMER_CIC_REPORTING_ERROR",

    RESET_CUSTOMER_CIC_REPORTING = "@@auth/RESET_CUSTOMER_CIC_REPORTING",
    RESET_CUSTOMER_CIC_REPORTING_SUCCESS = "@@auth/RESET_CUSTOMER_CIC_REPORTING_SUCCESS",
    RESET_CUSTOMER_CIC_REPORTING_ERROR = "@@auth/RESET_CUSTOMER_CIC_REPORTING_ERROR",

}

// Action Types
export type CustomerCICReportingActionDispatch = {
    type:
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS
    | CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING;

    payload: any;
}

// Reducer Types
export type CustomerCICReportingReducerDispatch = {
    type:

    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_SUCCESS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_ERROR

    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_SUCCESS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_ERROR

    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_SUCCESS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_ERROR

    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS
    | CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_ERROR

    | CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING
    | CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_SUCCESS
    | CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_ERROR

    | CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING;

    payload: {
        data?: FetchApiResponse<CustomerCICReporting>;
        error?: string;
    }

}

export type CreateCustomerCICReportingReduxState = {
    loading?: boolean;
    data?: CreateApiResponse<CustomerCICReporting>;
    error?: string | null;
};

export type CustomerCICReportingReduxState = {
    loading?: boolean;
    data?: FetchApiResponse<CustomerCICReporting>;
    error?: string | null;
}

//Saga Types
export type CreateCustomerCICReportingSaga = {
    type: string;
    payload: CreateCustomerCICReportingPayload;
};

export type UpdateCustomerCICReportingSaga = {
    type: string;
    payload: UpdateCustomerCICReportingPayload;
};
export type DeleteCustomerCICReportingSaga = {
    type: string;
    payload: DeleteCustomerCICReportingPayload;
};

export type ApproveRejectCustomerCICReportingSaga = {
    type: string;
    payload: ApproveRejectCustomerCICReportingPayload;
};

export type CustomerCICReportingFetchSaga = {
    type: string;
    payload: FilterMetadata;
}

export type CustomerCICReportingVersionsSaga = {
    type: string;
    payload: CustomerCICReportingVersionPayload;
}

export type CustomerCICReportingLatestVersionSaga = {
    type: string;
    payload: CustomerCICReportingLatestVersionPayload;
}

export type CustomerCICReportingDetailsSaga = {
    type: string;
    payload: CustomerCICReportingDetailsPayload;
}


// Payload Types

export type CustomerCICReportingVersionPayload = {
    externalID: string;
    payload: FilterMetadata;
}

export type CustomerCICReportingLatestVersionPayload = {
    externalID: string;
    status: string;
}

export type CustomerCICReportingDetailsPayload = {
    externalID: string;
    Id: string;

}

export type CustomerCICReporting = {
    customerExternalId: string;
    groupId: string;
    assetClassification: string;
    sector: string;
    bankingArrangement: string;
    leadBankExternalId: string;
    intRating: string;
    extRating: string;
    fraudWilful: string;
    npaDueFgnCtryRegln: boolean;
    resolutionPlanStatus: string;
    dateFilingNclt: Date;
    dateAdmissionNclt: Date
    techWoOuts: number;
    twoDate: Date
    secFundAmt: number
    assetClassificationCibilRaw: string;
    accountStatusRaw: string
    suitFiledStatusRaw: string
    suitAmount: number
    dateOfSuit: Date
    wilfulDefaultStatus: boolean
    dateClassifiedAsWilfulDefault: Date
    businessCategoryRaw: string
    businessOrIndustryTypeRaw: string
    status: number
    draft: boolean;
    makerRemarks: string
    checkerRemarks: string
}

export type UpdateCustomerCICReportingPayload = {
    draft?: boolean;
    externalId?: string;
    makerRemarks?: string
    customerExternalId: string | null;
    groupId: string | null;
    assetClassification: string | null;
    sector: string | null;
    bankingArrangement: string | null;
    leadBankExternalId: string | null;
    intRating: string | null;
    extRating: string | null;
    fraudWilful: string | null;
    npaDueFgnCtryRegln: boolean | null;
    resolutionPlanStatus: string | null;
    dateFilingNclt: Date | null;
    dateAdmissionNclt: Date | null
    techWoOuts: number | null;
    twoDate: Date | null;
    secFundAmt: number | null;
    assetClassificationCibilRaw: string | null;
    accountStatusRaw: string | null;
    suitFiledStatusRaw: string | null;
    suitAmount: number | null;
    dateOfSuit: Date | null;
    wilfulDefaultStatus: boolean | null;
    dateClassifiedAsWilfulDefault: Date | null;
    businessCategoryRaw: string | null;
    businessOrIndustryTypeRaw: string | null;
    individualNamePrefix: string | null;
    fullName: string | null;
    genderRaw: string | null;
    pan: string | null;
    dateOfBirth: Date | null;
}
export type UpdateCustomerCICReportingApiDataPayload = {
    draft?: boolean;
    externalId?: string;
    makerRemarks?: string
    customerExternalId: string | null;
    groupId: string | null;
    assetClassification: string | null;
    sector: string | null;
    bankingArrangement: string | null;
    leadBankExternalId: string | null;
    intRating: string | null;
    extRating: string | null;
    fraudWilful: string | null;
    npaDueFgnCtryRegln: boolean | null;
    resolutionPlanStatus: string | null;
    dateFilingNclt: Date | null;
    dateAdmissionNclt: Date | null
    techWoOuts: number | null;
    twoDate: Date | null;
    secFundAmt: number | null;
    assetClassificationCibilRaw: string | null;
    accountStatusRaw: string | null;
    suitFiledStatusRaw: string | null;
    suitAmount: number | null;
    dateOfSuit: Date | null;
    wilfulDefaultStatus: boolean | null;
    dateClassifiedAsWilfulDefault: Date | null;
    businessCategoryRaw: string | null;
    businessOrIndustryTypeRaw: string | null;
    individualNamePrefix: string | null;
    fullName: string | null;
    genderRaw: string | null;
    pan: string | null;
    dateOfBirth: Date | null;
}

export type ApproveRejectCustomerCICReportingPayload = {
    externalId: string;
    checkerRemarks: string;
}

export type DeleteCustomerCICReportingPayload = {
    externalId: string;
}

export type CreateCustomerCICReportingPayload = {
    draft?: boolean;
    makerRemarks?: string
    customerExternalId: string | null;
    groupId: string | null;
    assetClassification: string | null;
    sector: string | null;
    bankingArrangement: string | null;
    leadBankExternalId: string | null;
    intRating: string | null;
    extRating: string | null;
    fraudWilful: string | null;
    npaDueFgnCtryRegln: string | null;
    resolutionPlanStatus: string | null;
    dateFilingNclt: Date | null;
    dateAdmissionNclt: Date | null
    techWoOuts: number | null;
    twoDate: Date | null;
    secFundAmt: number | null;
    assetClassificationCibilRaw: string | null;
    accountStatusRaw: string | null;
    suitFiledStatusRaw: string | null;
    suitAmount: number | null;
    dateOfSuit: Date | null;
    wilfulDefaultStatus: string | null;
    dateClassifiedAsWilfulDefault: Date | null;
    businessCategoryRaw: string | null;
    businessOrIndustryTypeRaw: string | null;
    individualNamePrefix: string | null;
    fullName: string | null;
    genderRaw: string | null;
    pan: string | null;
    dateOfBirth: Date | null;
}

export type CreateCustomerCICReportingApiDataPayload = {
    draft?: boolean;
    makerRemarks?: string
    customerExternalId: string | null;
    groupId: string | null;
    assetClassification: string | null;
    sector: string | null;
    bankingArrangement: string | null;
    leadBankExternalId: string | null;
    intRating: string | null;
    extRating: string | null;
    fraudWilful: string | null;
    npaDueFgnCtryRegln: boolean | null;
    resolutionPlanStatus: string | null;
    dateFilingNclt: Date | null;
    dateAdmissionNclt: Date | null
    techWoOuts: number | null;
    twoDate: Date | null;
    secFundAmt: number | null;
    assetClassificationCibilRaw: string | null;
    accountStatusRaw: string | null;
    suitFiledStatusRaw: string | null;
    suitAmount: number | null;
    dateOfSuit: Date | null;
    wilfulDefaultStatus: boolean | null;
    dateClassifiedAsWilfulDefault: Date | null;
    businessCategoryRaw: string | null;
    businessOrIndustryTypeRaw: string | null;
    individualNamePrefix: string | null;
    fullName: string | null;
    genderRaw: string | null;
    pan: string | null;
    dateOfBirth: Date | null;
}
